// "use server";
import { rxFormEdit } from "@/src/models/lens/lensClient";
// import { z } from "zod";
import { IFormData } from ".";

// const schema = z.object({
//     ODError: z.string(),
// });

const formSubmitAction = async (value: IFormData) => {
    try {
        const formRes = await rxFormEdit(value);
        return formRes;
    } catch (e: any) {
        return e;
    }
};

export { formSubmitAction };
